<template>
  <div>
    <ProgressBar active-step="Let’s refresh your login information" />
    <div>
      <PageHeading :default-heading="pageHeader" />
      <form
        novalidate="novalidate"
        @submit.prevent
      >
        <div class="pvd-container container-divider">
          <p>
            {{ pd_content.page.already_have_some_information }}
          </p>
          <p>
            {{ pd_content.page.we_need_to_verify }}
          </p>
        </div>
        <PageNavigation
          primary-button-type="button"
          show-secondary-button="N"
          :disable-primary-button="shouldDisableNext"
          :primary-button-label="primaryButtonLabel"
          :page-exit-url="pd_content.overlay_exit_link.overview_url"
          @primary-button-clicked="nextButtonClicked"
        />
      </form>
    </div>
  </div>
</template>

<script>
import PageNavigation from '../components/PageNavigation.vue';
import PageHeading from '../components/PageHeading.vue';
import dataHelper from '../mixins/dataHelper';
import utility from '../mixins/utility';
import ProgressBar from '../components/ProgressBar.vue';
import measurement from '../mixins/measurement';

export default {
  name: 'PasswordResetInstructions',
  components: {
    PageNavigation,
    PageHeading,
    ProgressBar,
  },
  mixins: [dataHelper, utility, measurement],
  data() {
    return {
      windowLocation: window.location,
    };
  },
  computed: {
    pageHeader() {
      if (this.pd_content.page.page_header) {
        document.title = this.setTitle(this.pd_content.page.page_header);
      }
      return this.pd_content.page.page_header;
    },
  },
  mounted() {
  },
  methods: {
    nextButtonClicked() {
      window.location.assign(this.pd_envConfig.passwordResetWidget);
    },
  },
};
</script>

<style scoped>
</style>
